import activeSubscriptionStatus from 'constants/activeSubscriptionStatus';

const isActiveSubscription = (subscription = {}) =>
  activeSubscriptionStatus.includes(subscription.status);

export default isActiveSubscription;
